<template>
    <div>
      <!--修改权限等级-->
      <div class="logindiv" id="UpdateType_people">
        <div class="loginForm">
          <div style="width: 100%;height: 40px;background-color: #2d2d2d;margin: 0 auto;">
            <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: left;margin-left: 20px;">
              修改人员权限
            </span>
            <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: right;margin-right: 20px;">
              <a href="javascript:;" @click="close">
                <i class="el-icon-close"></i>
              </a>
            </span>
          </div>
          <div style="width: 300px;margin: 0 auto;">
            <el-form :model="UpdateType" style="margin-top: 30px;">
              <el-form-item prop="type">
                <el-select v-model="UpdateType.type" style="width: 100%;" placeholder="请选择">
                    <el-option
                      v-for="item in admin_type"
                      :key="item.id"
                      :label="item.type_name"
                      :value="item.id"
                      :disabled="item.disabled">
                    </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" :loading="loading" style="width: 300px;" @click="saveUpdate">保存</el-button>
              </el-form-item>
            </el-form>
          </div>
          <br>
        </div>
      </div>
      <!--修改密码-->
      <div class="logindiv" id="UpdateForm_people">
        <div class="loginForm">
          <div style="width: 100%;height: 40px;background-color: #2d2d2d;margin: 0 auto;">
            <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: left;margin-left: 20px;">
              修改密码
            </span>
            <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: right;margin-right: 20px;">
              <a href="javascript:;" @click="close">
                <i class="el-icon-close"></i>
              </a>
            </span>
          </div>
          <div style="width: 300px;margin: 0 auto;">
            <el-form :model="UpdateForm" style="margin-top: 30px;">
              <el-form-item prop="name">
                <el-input type="text" v-model="UpdateForm.pass" show-password placeholder="新密码"></el-input>
              </el-form-item>
              <el-form-item prop="phone">
                <el-input type="text" v-model="UpdateForm.repass" show-password placeholder="确认密码"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" :loading="loading" style="width: 300px;" @click="updatePass()">保存</el-button>
              </el-form-item>
            </el-form>
          </div>
          <br>
        </div>
      </div>
      <!--添加通知信息-->
      <div class="logindiv" id="AddForm_people">
        <div class="loginForm">
          <div style="width: 100%;height: 40px;background-color: #2d2d2d;margin: 0 auto;">
            <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: left;margin-left: 20px;">
              添加人员
            </span>
            <span style="line-height: 40px;color: #FFFFFF;font-size: 14px;float: right;margin-right: 20px;">
              <a href="javascript:;" @click="close">
                <i class="el-icon-close"></i>
              </a>
            </span>
          </div>
          <div style="width: 300px;margin: 0 auto;">
            <el-form :model="AddForm" :rules="rules" ref="AddForm" style="margin-top: 30px;">
              <el-form-item prop="name">
                <el-input type="text" v-model="AddForm.name" placeholder="姓名"></el-input>
              </el-form-item>
              <el-form-item prop="phone">
                <el-input type="text" v-model="AddForm.phone" placeholder="电话"></el-input>
              </el-form-item>
              <el-form-item prop="email">
                <el-input type="text" v-model="AddForm.email" placeholder="邮箱"></el-input>
              </el-form-item>
              <el-form-item prop="type">
                <el-select v-model="AddForm.type" style="width: 100%;" clearable placeholder="请选择">
                    <el-option
                      v-for="item in admin_type"
                      :key="item.id"
                      :label="item.type_name"
                      :value="item.id"
                      :disabled="item.disabled">
                    </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" :loading="loading" style="width: 300px;" @click="AddAdmin">提交</el-button>
              </el-form-item>
            </el-form>
          </div>
          <br>
        </div>
      </div>
      <div>
        <el-container>
          <el-header style="background-color:white;margin-top: 5px;height: 40px;">
            <el-form :inline="true" :model="formInline" class="demo-form-inline" size="mini">
              <el-form-item>
                <el-button type="primary" class="btn" @click="Addwindow()"><i class="el-icon-circle-plus-outline"></i>添加人员</el-button>
              </el-form-item>
              <el-form-item label="用户名">
                <el-input v-model="formInline.adminname" placeholder="用户名" class="elInput"></el-input>
              </el-form-item>
              <el-form-item label="名称">
                <el-input v-model="formInline.name" placeholder="名称" class="elInput"></el-input>
              </el-form-item>
              <el-form-item label="权限信息">
                <el-select v-model="formInline.type" style="width: 100%;" clearable placeholder="权限内容">
                    <el-option
                      v-for="item in admin_type"
                      :key="item.id"
                      :label="item.type_name"
                      :value="item.id"
                      :disabled="item.disabled">
                    </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" class="btn" @click="getData()"><i class="el-icon-search"></i>查询</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="danger" class="btn" @click="resetting()"><i class="el-icon-refresh"></i>重置</el-button>
              </el-form-item>
            </el-form>
          </el-header>
          <el-main class="elMain">
            <el-table v-loading="loading" :data="tableData" height="100%" stripe border size="medium ">
              <el-table-column align="center" label="ID" prop="id" width="300"></el-table-column>
              <el-table-column align="center" label="用户名" prop="adminname" width="200"></el-table-column>
              <el-table-column align="center" label="名称" prop="name"></el-table-column>
              <el-table-column align="center" label="性别" prop="sex" width="100"></el-table-column>
              <el-table-column align="center" label="电话" prop="phone" width="200"></el-table-column>
              <el-table-column align="center" label="邮箱" prop="email" width="200"></el-table-column>
              <el-table-column align="center" label="权限信息" prop="type_name" width="150"></el-table-column>
              <el-table-column fixed="right" label="操作" width="300">
                <template slot-scope="scope">
                  <span>
                    <el-button size="small" @click="Updatewindow(scope.row)">修改密码</el-button>
                  </span>
                  <span>
                    <el-button size="small" @click="UpdateTypes(scope.row)">修改权限等级</el-button>
                  </span>
                  <span>
                    <el-popconfirm
                      confirmButtonText='好的'
                      cancelButtonText='不用了'
                      icon="el-icon-info"
                      iconColor="red"
                      title="这是一段内容确定删除吗？"
                      @onConfirm="deletes(scope.$index, scope.row)"
                    >
                      <el-button size="small" slot="reference">删除</el-button>
                    </el-popconfirm>
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </el-main>
          <el-footer>
            <div style="padding: 15px 0;text-align: right;">
              <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="formInline.pageNum"
                :page-sizes="pageSizes" :page-size="formInline.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pageTotal">
              </el-pagination>
            </div>
          </el-footer>
        </el-container>
      </div>
    </div>
</template>

<script>
  import {commonAPI} from '@/api/commonAPI'
  export default {
    data() {
      var name = (rule, value, callback) => {
        if (value.length === 0) {
          callback(new Error('请输入姓名'))
        } else {
          callback()
        }
      }
      var phone = (rule, value, callback) => {
        let phonePD=/^1[3456789]\d{9}$/;
        if (value.length === 0) {
          return callback(new Error('请输入联系电话'))
        }else if(!phonePD.test(value)){
          return callback(new Error('输入的号码不正确'))
        } else {
          callback()
        }
      }
      var email = (rule, value, callback) => {
        let EmailPD=/^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
        if (value.length === 0) {
          return callback(new Error('请输入电子邮箱'))
        }else if(!EmailPD.test(value)){
          return callback(new Error('输入的邮箱号不正确'))
        } else {
          callback()
        }
      }
      var type = (rule, value, callback) => {
        if (value.length === 0) {
          callback(new Error('请选择权限'))
        } else {
          callback()
        }
      }
      return {
        UpdateType:{
          id:'',
          type:'',
        },
        adminsalt:'havetorich',
        UpdateForm:{
          id:'',
          pass:'',
          repass:'',
        },
        admin_type:'',
        data:'',
        tableData: [],
        loading: false,
        formInline: {
          adminname:'',
          name:'',
          type:'',
          pageNum:1,
          pageSize:10
        },
        formInlines: {
          pageNum:1,
          pageSize:999
        },
        pageSizes:[5, 10, 15, 20],
        pageTotal:0,
        AddForm:{
          name:'',
          phone:'',
          email:'',
          type:''
        },
        rules: {
          name: [{
            required: true,
            trigger: 'blur',
            validator: name
          }],
          phone: [{
            required: true,
            trigger: 'blur',
            validator: phone
          }],
          email: [{
            required: true,
            trigger: 'blur',
            validator: email
          }],
          type: [{
            required: true,
            trigger: 'blur',
            validator: type
          }]
        },
      }
    },
    //页面开启时执行
    mounted(){
      this.chark();
      this.getData();
      this.getData_admin_type();
    },
    methods: {
      //进行判定
      chark(){
        this.$emit("parentHandle", 2)
      },
      //修改权限
      saveUpdate(){
        if(this.UpdateType.type.length<=0||this.UpdateType.type==''){
          this.$notify({//这里采用element ui的一个错误显示效果模板
            title: '提示',
            message: "请选择权限选项",
            position: 'bottom-right',
            type: 'error'
          });
          return false;
        }
        this.UpdateType.admin_id=this.$store.state.a_id;
        commonAPI('AdminupdateType',this.UpdateType).then(res => {
          let data = res.data;
          //console.log(res.data.rows);
          if(this.response.response(data)){
            this.getData();
            this.close();
          }
        }).catch(error=>{
          this.loading = false;
          this.$notify({//这里采用element ui的一个错误显示效果模板
            title: '提示',
            message: error.message,
            position: 'bottom-right',
            type: 'error'
          });
          })
      },
      //修改密码
      updatePass(){
        if(this.UpdateForm.pass.length<8){
          this.$notify({//这里采用element ui的一个错误显示效果模板
            title: '提示',
            message: "密码长度不得小于8位",
            position: 'bottom-right',
            type: 'error'
          });
          return false;
        }
        if(this.UpdateForm.pass==''||this.UpdateForm.repass==''){
          this.$notify({//这里采用element ui的一个错误显示效果模板
            title: '提示',
            message: "信息未填写完整!",
            position: 'bottom-right',
            type: 'error'
          });
          return false;
        }
        if(this.UpdateForm.pass!==this.UpdateForm.repass){
          this.$notify({//这里采用element ui的一个错误显示效果模板
            title: '提示',
            message: "两次密码不一致！",
            position: 'bottom-right',
            type: 'error'
          });
          return false;
        }
        this.UpdateForm.pass=this.$md5(this.UpdateForm.pass+this.adminsalt);
        this.UpdateForm.repass=this.$md5(this.UpdateForm.repass+this.adminsalt);
        this.UpdateForm.admin_id=this.$store.state.a_id;
        commonAPI('AdminupdatePassword',this.UpdateForm).then(res => {
          let data = res.data;
          //console.log(res.data.rows);
          if(this.response.response(data)){
            this.getData();
            this.close();
          }
        }).catch(error=>{
          this.loading = false;
          this.$notify({//这里采用element ui的一个错误显示效果模板
            title: '提示',
            message: error.message,
            position: 'bottom-right',
            type: 'error'
          });
          })
      },
      //重置查询
      resetting() {
        this.formInline.adminname = '';
        this.formInline.name = '';
        this.formInline.type = '';
        this.getData();
      },
      //添加内容
      AddAdmin(){
        this.$refs.AddForm.validate(valid => {
        if (valid) {
          this.AddForm.admin_id=this.$store.state.a_id;
          commonAPI('AddAdmin',this.AddForm).then(res => {
            let data = res.data;
            //console.log(res.data.rows);
            if(this.response.response(data)){
              this.AddForm.name='';
              this.AddForm.phone='';
              this.AddForm.email='';
              this.getData();
              this.close();
            }
          }).catch(error=>{
            this.loading = false;
            this.$notify({//这里采用element ui的一个错误显示效果模板
              title: '提示',
              message: error.message,
              position: 'bottom-right',
              type: 'error'
            });
            })
        }else{
          return false;
        }
        })
      },
      //打开窗口
      Updatewindow(data){
        this.UpdateForm.id=data.id;
        document.getElementById('UpdateForm_people').style.display='block';
        document.getElementById('zhedang').style.display='block';
      },
      //打开窗口
      UpdateTypes(data){
        this.UpdateType.id=data.id;
        document.getElementById('UpdateType_people').style.display='block';
        document.getElementById('zhedang').style.display='block';
      },
      Addwindow(row){
        //this.AddForm.message_id=row.id;
        document.getElementById('AddForm_people').style.display='block';
        document.getElementById('zhedang').style.display='block';
        //console.log('打开窗口');
      },
      //删除
      deletes(index, row) {
        let admin_id=this.$store.state.a_id;
        row.admin_id=admin_id;
        //console.log(index, row);
        commonAPI('deleteAdmin',row).then(res => {
          let data = res.data;
          //console.log(res.data.rows);
          if(this.response.response(data)){
            this.getData();
          }
        }).catch(error=>{
            this.loading = false;
            this.$notify({//这里采用element ui的一个错误显示效果模板
              title: '提示',
              message: error.message,
              position: 'bottom-right',
              type: 'error'
            });
            })
      },
      //获取权限信息
      getData_admin_type() {
          commonAPI('queryAdmin_type',this.formInlines).then(res => {
            this.loading = false;
            let data = res.data.data.rows;
            data[0].disabled=true;
            data[1].disabled=true;
            this.admin_type = data;
            //console.log(res.data.rows);
          })
      },
      //查询
      getData() {
        this.loading = true,
          commonAPI('queryAdminList_people',this.formInline).then(res => {
            this.loading = false;
            let data = res.data.data;
            this.tableData = data.rows;
            this.pageTotal=data.total;
            //console.log(res.data.rows);
          })
      },
      onSubmit() {
        this.getData();
      },
      handleSizeChange(val) {
        //console.log(`每页 ${val} 条`);
        this.formInline.pageSize=val;
        this.formInline.pageNum=1;
        this.getData();
      },
      handleCurrentChange(val) {
        //console.log(`当前页: ${val}`);
        this.formInline.pageNum=val;
        this.getData();
      },
      close(){
        this.AddForm.title='';
        this.AddForm.content='';
        this.UpdateForm.repass='';
        this.UpdateForm.pass='';
        this.UpdateForm.id='';
        this.UpdateType.id='';
        this.UpdateType.type='';
        document.getElementById('UpdateType_people').style.display='none';
        document.getElementById('UpdateForm_people').style.display='none';
        document.getElementById('AddForm_people').style.display='none';
        document.getElementById('zhedang').style.display='none';
      },
    }
  }
</script>

<style scoped>
  .elInput,
  .btn {
    margin-top: 0px;
  }
  .el-main {
    padding: 5px 10px;
  }
  .elMain{
    height: 700px;
  }
  .el-table th {
    height: 45px;
    font-size: 16px;
    font-family: 微软雅黑;
    font-weight: 500;
    color: darkblue;
  }
  /**登录框架*/
  .logindiv{
    position: fixed;
    top: 25%;
    left:0;
    right:0;
    bottom: 0;
    margin:0 auto;
    padding: 20px;
    border: 0px solid #ddd;
    z-index:2002;
    overflow: auto;
    text-align: center;
    display: none;
  }
  .loginForm{
    margin: 0 auto;
    width: 550px;
    background-color: #fff;
    -webkit-box-shadow: #333 0px 5px 5px;
    -moz-box-shadow: #333 0px 5px 5px;
    box-shadow: #333 0px 5px 5px;
  }
  .loginForm a{
    color: #fff;
  }
  .loginForm a:hover{
    color: #d6d6d6;
  }

  /**Orderinfor框架*/
  .Orderinfordiv{
    position: fixed;
    top: 13%;
    left:0;
    right:0;
    bottom: 0;
    margin:0 auto;
    padding: 20px;
    border: 0px solid #ddd;
    z-index:2002;
    overflow: auto;
    display: none;
  }
  .OrderinforForm{
    margin: 0 auto;
    width: 900px;
    background-color: #fff;
    -webkit-box-shadow: #333 0px 5px 5px;
    -moz-box-shadow: #333 0px 5px 5px;
    box-shadow: #333 0px 5px 5px;
  }
  .OrderinforForm a{
    color: #fff;
  }
  .OrderinforForm a:hover{
    color: #d6d6d6;
  }
  .playlistbox_botton{
     width: 900px;margin: 0 auto;
     overflow: hidden;
     height: 633px;
     overflow-y: scroll;
   }
   /**滚动条样式*/
   .playlistbox_botton::-webkit-scrollbar{
     width: 5px;
   }
   .playlistbox_botton::-webkit-scrollbar-thumb{
     border-radius: 10px;
     -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
     background: #535353;
   }
   .playlistbox_botton::-webkit-scrollbar-thumb{
     -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
     border-radius: 10px;
     background: #EDEDED;
   }
   /**！Orderinfor框架*/
</style>



// WEBPACK FOOTER //
// src/admin/views/systemAdmin/People.vue